import classNames from 'classnames';
import React from 'react';
import { SectionTilesProps } from '../../utils/SectionProps';
import SectionHeader from './partials/SectionHeader';

const propTypes = {
  ...SectionTilesProps.types
}

const defaultProps = {
  ...SectionTilesProps.defaults
}
const FeaturesTiles = ({
  className,
  topOuterDivider,
  bottomOuterDivider,
  topDivider,
  bottomDivider,
  hasBgColor,
  invertColor,
  pushLeft,
  ...props
}) => {

  const outerClasses = classNames(
    'features-tiles section',
    topOuterDivider && 'has-top-divider',
    bottomOuterDivider && 'has-bottom-divider',
    hasBgColor && 'has-bg-color',
    invertColor && 'invert-color',
    className
  );

  const innerClasses = classNames(
    'features-tiles-inner section-inner pt-0',
    topDivider && 'has-top-divider',
    bottomDivider && 'has-bottom-divider'
  );

  const tilesClasses = classNames(
    'tiles-wrap center-content',
    pushLeft && 'push-left'
  );

  const sectionHeader = {
    title: 'Fique tranquilo! Seus dados estão seguros.',
    paragraph: 'Todas as suas informações pessoais recolhidas, serão usadas para o ajudar a tornar a sua visita no nosso site o mais produtiva e agradável possível. A garantia da confidencialidade dos dados pessoais dos utilizadores do nosso site é importante para o Silo Virtual.'
  };

  const sectionHeader2 = {
    title: '',
    paragraph: 'Todas as informações pessoais relativas a membros, assinantes, clientes ou visitantes que usem o Silo Virtual serão tratadas em concordância com a Lei da Proteção de Dados Pessoais de 26 de outubro de 1998 (Lei n.º 67/98).'
  };

  const sectionHeader3 = {
    title: '',
    paragraph: 'O uso do Silo Virtual pressupõe a aceitação deste Acordo de privacidade. A equipe do Silo Virtual reserva-se ao direito de alterar este acordo sem aviso prévio. Deste modo, recomendamos que consulte a nossa política de privacidade com regularidade de forma a estar sempre atualizado.'
  };

  const sectionHeader4 = {
    title: 'Os anúncios',
    paragraph: 'O aplicativo foi desenvolvido com foco na experiência do usuário e, por isso, não possui anúncios. Assim, você pode aproveitar todas as funcionalidades e navegar sem interrupções, com um ambiente limpo e livre de distrações. Nosso objetivo é oferecer uma experiência mais agradável e fluida, sem interrupções indesejadas.'
  };

  const sectionHeader5 = {
    title: 'Permissões de acesso',
    paragraph: 'O acesso da sua localização é usada apenas para a liberação do seu dispositivo em nossa plataforma. Essa informação não será utilizada em divulgações ou compartilhamentos. O acesso da sua localização se da unicamente a integração dos dados registrados pelo aplicativo. Essa informação não será utilizada em divulgações ou compartilhamentos.'
  };

  const sectionHeader6 = {
    title: 'Como entrar em contato com a Ruralhub em caso de dúvidas',
    paragraph: 'Saiba mais sobre como a privacidade funciona em nosso aplicativo. Se você tem dúvidas sobre esta Política ou perguntas, queixas ou solicitações relacionadas às suas informações, entre em contato conosco conforme descrito'
  };

  return (
    <section
      {...props}
      className={outerClasses}
    >
      <div className="container">
        <div className={innerClasses}>
          <SectionHeader data={sectionHeader} className="center-content" />
          <SectionHeader data={sectionHeader2} className="center-content" />
          <SectionHeader data={sectionHeader3} className="center-content" />
          <SectionHeader data={sectionHeader4} className="center-content" />
          <SectionHeader data={sectionHeader5} className="center-content" />
          <SectionHeader data={sectionHeader6} className="center-content" />
        </div>
      </div>
    </section>
  );
}

FeaturesTiles.propTypes = propTypes;
FeaturesTiles.defaultProps = defaultProps;

export default FeaturesTiles;